import {
  CheckboxGroupField as BaseCheckboxGroupField,
  type CheckboxGroupProps,
} from '@wyz/ui';
import { useI18n } from '~/common/context';
import { TranslationKeys } from '~/common/types';

type CheckboxGroupFieldProps<TValue extends string | number> = Omit<
  CheckboxGroupProps<keyof TranslationKeys, TValue>,
  'translate'
>;

function CheckboxGroupField<TValue extends string | number>(
  props: CheckboxGroupFieldProps<TValue>,
) {
  const { t } = useI18n();

  return <BaseCheckboxGroupField {...props} translate={t} />;
}

export default CheckboxGroupField;
